"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetaDataFiltersInvoice = void 0;
exports.MetaDataFiltersInvoice = [
    {
        field: 'invoiceDetails.metadata.createdAt',
        type: 'TIMESTAMP',
        alias: 'Created At',
        shortName: 'Created',
        allowedOperators: 'ALL',
        format: 'ISO',
    },
    {
        field: 'invoiceDetails.metadata.lastUpdatedAt',
        type: 'TIMESTAMP',
        alias: 'Last Updated At',
        shortName: 'Last Updated',
        allowedOperators: 'ALL',
        format: 'ISO',
    },
];
//# sourceMappingURL=meta-data-invoice.js.map